import ApiService from "@/libs/ApiServices";
import {IStaticPage} from "@/types/global.types";
import {Collapse} from "antd";
import {GetServerSideProps} from "next";
import React from "react";

const OrderStatus: React.FC<{data: IStaticPage}> = ({data}) => {
  return (
    <section className="mt-10 mb-32 md:mt-20 wrapper-sm">
      <h1 className="mb-10 text-base font-semibold text-center text-blue-dark">{data?.title}</h1>

      {data.content ? <div className="mb-10" dangerouslySetInnerHTML={{__html: data.content || ""}}></div> : null}

      {data?.static_details.length ? (
        <Collapse
          className="flex flex-col static-page-dropdown"
          defaultActiveKey={["0"]}
          ghost
          expandIconPosition="end"
          expandIcon={({isActive}) =>
            isActive ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                <path d="M6 0.806641V12.8066" stroke="#48B9C7" />
                <path d="M0 6.80664L12 6.80664" stroke="#48B9C7" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="2" viewBox="0 0 12 2" fill="none">
                <path d="M0 0.719727L12 0.719726" stroke="#48B9C7" />
              </svg>
            )
          }
        >
          {data.static_details.map((static_detail, index) => (
            <Collapse.Panel header={static_detail.title} key={index}>
              <div
                className="leading-relaxed"
                dangerouslySetInnerHTML={{__html: static_detail.description || ""}}
              ></div>
            </Collapse.Panel>
          ))}
        </Collapse>
      ) : null}
    </section>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  try {
    const res = await ApiService.get("/static/detail/14");
    if (res.data.status !== 200) {
      throw new Error(res.data.message);
    }

    let url = `${process.env.NEXT_PUBLIC_SELF_DOMAIN}/order-status`;
    const meta = {
      title: `Wardah, ${res.data.data.title}`,
      url: url,
    };

    return {props: {data: res.data.data, meta}};
  } catch (error) {
    return {notFound: true};
  }
};

export default OrderStatus;
